import { Accordion } from '@dreryk/react-components';

import { PatientGroupsSettings } from '~libs.desktop.patient-groups';

import { generalSettingsTranslationKeys } from '../../translations';

import { CalendarSettings } from './calendar/CalendarSettings';
import { ConfidentialitySettings } from './confidentialitySettings/ConfidentialitySettings';
import { StyledAccordionSectionContent } from './GeneralSettingsPanel.styled';
import { SurveySettings } from './survey/SurveySettings';

const t = generalSettingsTranslationKeys;

export const GeneralSettingsPanel = (): JSX.Element => {
   return (
      <Accordion testId={'generalSettings'} allowOpenMultipleSections>
         <Accordion.Section id={'survey'} testId={'survey'} label={t.survey.header}>
            <StyledAccordionSectionContent>
               <SurveySettings />
            </StyledAccordionSectionContent>
         </Accordion.Section>
         <Accordion.Section id={'calendar'} testId={'calendar'} label={t.calendar.header}>
            <StyledAccordionSectionContent>
               <CalendarSettings />
            </StyledAccordionSectionContent>
         </Accordion.Section>
         <Accordion.Section id={'patientGroups'} testId={'patientGroups'} label={t.patientGroups.header}>
            <StyledAccordionSectionContent>
               <PatientGroupsSettings />
            </StyledAccordionSectionContent>
         </Accordion.Section>
         <Accordion.Section id={'confidentiality'} testId={'confidentiality'} label={t.confidentialitySettings.header}>
            <StyledAccordionSectionContent>
               <ConfidentialitySettings />
            </StyledAccordionSectionContent>
         </Accordion.Section>
      </Accordion>
   );
};
